import axiosInstance from "../utils/axiosInstance";

// const API_BASE_URL = import.meta.env.VITE_API_URL || "";

interface PresignedUrl {
    filename: string;
    key: string;
    url: string;
  }

export const generatePresignedUrls = async (
    files: Array<{ filename: string; contentType: string; size?: number }>
  ): Promise<PresignedUrl[]> => {
    try {
      // Headers automatically handled by axiosInstance
      const response = await axiosInstance.post(
        `/utility/generate-presigned-urls`,
        { files }
        // Removed manual header setting
      );
      return response.data.presignedUrls; // Should include an array of { filename, key, url }
    } catch (error: any) {
      console.error("Error generating presigned URLs:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Failed to generate pre-signed URLs."
      );
    }
  };